module.exports = __webpack_public_path__ + "img/waves-9.9d240915.webp";